import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LockersIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LockersIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M10.1867 4.3136H6.18225C5.76874 4.3136 5.43209 4.65026 5.43209 5.06376C5.43209 5.47726 5.76875 5.81324 6.18225 5.81324H10.1867C10.6003 5.81324 10.9362 5.47726 10.9362 5.06376C10.9362 4.65026 10.6002 4.3136 10.1867 4.3136Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.1867 6.62598H6.18225C5.76874 6.62598 5.43209 6.96264 5.43209 7.37614C5.43209 7.78964 5.76875 8.12562 6.18225 8.12562H10.1867C10.6003 8.12562 10.9362 7.78964 10.9362 7.37614C10.9362 6.96264 10.6002 6.62598 10.1867 6.62598Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.1867 8.93836H6.18225C5.76874 8.93836 5.43209 9.27502 5.43209 9.68852C5.43209 10.102 5.76875 10.438 6.18225 10.438H10.1867C10.6003 10.438 10.9362 10.102 10.9362 9.68852C10.9362 9.27502 10.6002 8.93836 10.1867 8.93836Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.6216 15.4695V13.1571C6.6216 12.7436 6.28562 12.4076 5.87212 12.4076C5.45862 12.4076 5.12196 12.7436 5.12196 13.1571V15.4695C5.12196 15.883 5.45862 16.2196 5.87212 16.2196C6.28562 16.2196 6.6216 15.883 6.6216 15.4695Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.889 2.00122H13.9804C13.5554 2.00122 13.1446 2.142 12.8093 2.40045C12.4747 2.14201 12.0645 2.00122 11.6388 2.00122H4.73021C3.67128 2.00122 2.80957 2.86292 2.80957 3.92186V20.0806C2.80957 21.1396 3.67127 22.0006 4.73021 22.0006H11.6388C12.0652 22.0006 12.4753 21.8598 12.8092 21.602C13.1439 21.8598 13.5547 22.0006 13.9804 22.0006H20.889C21.9479 22.0006 22.8096 21.1396 22.8096 20.0806V3.92185C22.8096 2.86292 21.9479 2.00122 20.889 2.00122ZM21.3093 20.0806C21.3093 20.3125 21.1209 20.5009 20.889 20.5009H13.9804C13.7485 20.5009 13.5594 20.3125 13.5594 20.0806V3.92185C13.5594 3.68993 13.7485 3.50086 13.9804 3.50086H20.889C21.1209 3.50086 21.3093 3.68993 21.3093 3.92185V20.0806ZM12.0598 3.92185V20.0806C12.0598 20.3125 11.8707 20.5009 11.6388 20.5009H4.73021C4.49829 20.5009 4.30922 20.3125 4.30922 20.0806V3.92185C4.30922 3.68993 4.49829 3.50086 4.73021 3.50086H11.6388C11.8707 3.50086 12.0598 3.68993 12.0598 3.92185Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.437 4.3136H15.4325C15.0189 4.3136 14.6823 4.65026 14.6823 5.06376C14.6823 5.47726 15.019 5.81324 15.4325 5.81324H19.437C19.8505 5.81324 20.1864 5.47726 20.1864 5.06376C20.1864 4.65026 19.8505 4.3136 19.437 4.3136Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.437 6.62598H15.4325C15.0189 6.62598 14.6823 6.96264 14.6823 7.37614C14.6823 7.78964 15.019 8.12562 15.4325 8.12562H19.437C19.8505 8.12562 20.1864 7.78964 20.1864 7.37614C20.1864 6.96264 19.8505 6.62598 19.437 6.62598Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.437 8.93836H15.4325C15.0189 8.93836 14.6823 9.27502 14.6823 9.68852C14.6823 10.102 15.019 10.438 15.4325 10.438H19.437C19.8505 10.438 20.1864 10.102 20.1864 9.68852C20.1864 9.27502 19.8505 8.93836 19.437 8.93836Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.5909 18.1886H16.2785C15.865 18.1886 15.5284 18.5252 15.5284 18.9387C15.5284 19.3522 15.865 19.6882 16.2785 19.6882H18.5909C19.0044 19.6882 19.3404 19.3522 19.3404 18.9387C19.3404 18.5252 19.0044 18.1886 18.5909 18.1886Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.34069 18.1886H7.02831C6.6148 18.1886 6.27815 18.5252 6.27815 18.9387C6.27815 19.3522 6.61481 19.6882 7.02831 19.6882H9.34069C9.7542 19.6882 10.0909 19.3522 10.0909 18.9387C10.0909 18.5252 9.75419 18.1886 9.34069 18.1886Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.8718 15.4695V13.1571C15.8718 12.7436 15.5351 12.4076 15.1216 12.4076C14.7081 12.4076 14.3721 12.7436 14.3721 13.1571V15.4695C14.3721 15.883 14.7081 16.2196 15.1216 16.2196C15.5352 16.2196 15.8718 15.883 15.8718 15.4695Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LockersIcon;
